import { Button } from 'antd';
import styled from 'styled-components';

import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #ffeac2;

  @media (min-width: ${BREAKPOINTS.phone}) {
    padding: 16px;
    gap: 16px;
    align-items: start;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding: 16px 24px;
    gap: 16px;
    align-items: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ProductNameContainer = styled.div`
  display: flex;
  gap: 4px;
  font-size: 1.25rem;

  @media (min-width: ${BREAKPOINTS.phone}) {
    flex-direction: column;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
  }
`;

export const BuyGfp = styled.div`
  color: #d16d0f;
  font-weight: 700;
`;

export const ProductName = styled.div`
  color: black;
  font-weight: 400;

  @media (min-width: ${BREAKPOINTS.phone}) {
    font-size: 0.75rem;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    font-size: 1.25rem;
  }
`;

export const UnderText = styled.span`
  font-weight: 400;
  color: #595959;

  @media (min-width: ${BREAKPOINTS.phone}) {
    font-size: 0.625rem;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    font-size: 0.75rem;
  }
`;

export const FaqButton = styled(Button)`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const FaqButtonText = styled.div`
  @media (max-width: ${BREAKPOINTS.tabletMini}) {
    display: none;
  }
`;

export const QuestionMark = styled.div`
  border-radius: 50%;
  border: 1px solid black;
  width: 16px;
  font-size: 12px;
  height: 17px;
  margin-top: -2px;
`;
